// extracted by mini-css-extract-plugin
module.exports = {"container":"PreOrderTag_container__0EiTz"};